var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfileCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80039 5.99998C3.47491 5.99998 2.40039 7.07449 2.40039 8.39998V18C2.40039 19.3255 3.47491 20.4 4.80039 20.4H19.2004C20.5259 20.4 21.6004 19.3255 21.6004 18V8.39998C21.6004 7.07449 20.5259 5.99998 19.2004 5.99998H17.2974C16.9792 5.99998 16.674 5.87355 16.4489 5.6485L15.1033 4.30292C14.6532 3.85283 14.0428 3.59998 13.4063 3.59998H10.5945C9.95798 3.59998 9.34754 3.85283 8.89745 4.30292L7.55186 5.6485C7.32682 5.87355 7.02159 5.99998 6.70333 5.99998H4.80039ZM12.0004 16.8C13.9886 16.8 15.6004 15.1882 15.6004 13.2C15.6004 11.2118 13.9886 9.59998 12.0004 9.59998C10.0122 9.59998 8.40039 11.2118 8.40039 13.2C8.40039 15.1882 10.0122 16.8 12.0004 16.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileCamera);
export default __webpack_public_path__ + "static/media/icon-profile-camera.0c5b7426398f9a85d582a2067a14bccc.svg";
export { ForwardRef as ReactComponent };